<template>
  <h1 class="page-title">
    <v-text-field
      v-if="editable"
      :loading="loading"
      :error="error"
      :value="content"
      @change="val => { content = val; }"
    />
    <template v-else>
      {{ content }}
    </template>
  </h1>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      currentProject: 'projects/currentProject',
      currentRecording: 'recordings/current',
    }),
    content: {
      get() {
        if (this.$route.name === 'Issues') return this.currentProject.name;
        if (this.$route.fullPath === '/account') return 'Account Settings';
        if (this.$route.fullPath === '/') return 'Projects';
        if (this.currentRecording) return this.currentRecording.name;
        if (this.currentProject) return this.currentProject.name;
        return 'Projects';
      },
      set(val) {
        if (!this.editable) throw new Error('Unable to set non-editable name');
        if (this.currentRecording) return this.updateRecordingName(val);
        if (this.currentProject) return this.updateProjectName(val);
        throw new Error('Unsure what to update...');
      },
    },
    loading() {
      if (this.currentRecording) return this.currentRecording.updating;
      if (this.currentProject) return this.currentProject.updating;
      return false;
    },
    error() {
      if (this.currentRecording) return this.currentRecording.error;
      if (this.currentProject) return this.currentProject.error;
      return false;
    },
    editable() {
      if (this.$route.name === 'Account Settings') return false;
      if (this.$route.fullPath === '/') return false;
      return !!(this.currentRecording || this.currentProject);
    },
  },
  methods: {
    updateRecordingName(name) {
      this.$store.dispatch('recordings/update', { recordingId: this.currentRecording._id, name });
    },
    updateProjectName(name) {
      this.$store.dispatch('projects/update', { _id: this.currentProject._id, name });
    },
  },
};
</script>

<style lang="scss">
.page-title, .page-title .input-group--text-field input {
  font-family: 'Karla', sans-serif;
  color: #ffffff;
  margin-left: 15px;
  font-size: 34px;
  font-weight: bold;
  line-height: 1.12;
}
.page-title .input-group--text-field input {
  height: 44px;
}

</style>



// WEBPACK FOOTER //
// src/components/PageTitle.vue